// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2DEW4","name":"ConsentHeader_name__36Imy","birthday":"ConsentHeader_birthday__YjdOs","skeleton":"ConsentHeader_skeleton__3LovT"};